import jwtDecode from 'jwt-decode';
import { urls } from 'Utilities/dataHelpers';
import * as log from 'Utilities/log';
import mediator from 'Utilities/mediator';
export const signIn = (email, password, app) => {
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'POST',
      url: urls.libreSharingApiCountryUrl + `v1/login?include=patient`,
      headers: {
        'X-User-Agent': app
      },
      data: {
        email,
        password,
        consents: [{
          id: 'touLibre',
          action: 'accept'
        }, {
          id: 'pp',
          action: 'accept'
        }]
      }
    }).then(result => {
      if (result.data) {
        const decodedToken = jwtDecode(result.data.access_token);
        resolve({
          accessToken: result.data.access_token,
          accountId: decodedToken.id,
          expires: decodedToken.exp,
          country: decodedToken.country,
          verificationTasks: result.data.verificationTasks,
          patient: result.data.include.patient
        });
        return;
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const forgotPass = (email, app, pId) => {
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'POST',
      url: urls.libreSharingApiCountryUrl + 'v1/password/forgot',
      headers: {
        'X-User-Agent': app
      },
      data: {
        email,
        partnerID: pId
      }
    }).then(result => {
      resolve(result.data);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const resetPass = (password, tokenID, app) => {
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'POST',
      url: urls.libreSharingApiCountryUrl + 'v1/password/reset',
      headers: {
        'X-User-Agent': app
      },
      data: {
        password,
        tokenID
      }
    }).then(result => {
      resolve(result.data);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const getLegacyToken = (app, accountId, accessToken) => {
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'GET',
      url: urls.libreSharingApiCountryUrl + `v1/patients/${accountId}/legacy-sharing-webviews-token`,
      headers: {
        'X-User-Agent': app,
        Authorization: `Bearer ${accessToken}`
      }
    }).then(result => {
      if (result.data) {
        resolve(result.data.tokenId);
        return;
      }
      reject();
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};